import ApartmentNameChip from './ApartmentNameChip';

export default ApartmentNameChip;
